import { type AnchorHTMLAttributes } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'

export interface LinkedInLinkProps {
    url?: string
    ariaLabel?: string
    title?: string | null
    className?: string
    iconClassName?: string
}

const cleanLinkedInUrl = (url?: string) => {
    if (!url) return undefined
    try {
        let trimmed = url.trim()
        trimmed = trimmed.replace(/[?#].*$/, '')
        trimmed = trimmed.replace(/\/+$/, '')
        if (!/^https?:\/\//i.test(trimmed)) {
            trimmed = `https://${trimmed}`
        }
        const parsed = new URL(trimmed)
        parsed.protocol = 'https:'
        parsed.hostname = parsed.hostname.toLowerCase()
        return parsed.toString().replace(/\/+$/, '')
    } catch {
        return url
    }
}

export default function LinkedInLink({
    url,
    ariaLabel,
    title,
    className,
    iconClassName,
}: LinkedInLinkProps) {
    if (!url) return null

    const cleanedUrl = cleanLinkedInUrl(url) ?? url
    const linkTitle =
        title === null || title === '' ? undefined : (title ?? cleanedUrl)

    const anchorProps: AnchorHTMLAttributes<HTMLAnchorElement> = {
        href: cleanedUrl,
        target: '_blank',
        rel: 'noopener noreferrer',
    }

    if (ariaLabel) {
        anchorProps['aria-label'] = ariaLabel
    }

    if (className) {
        anchorProps.className = className
    }

    if (linkTitle) {
        anchorProps.title = linkTitle
    }

    return (
        <a {...anchorProps}>
            <FontAwesomeIcon
                icon={faLinkedin}
                className={
                    iconClassName ?? 'text-gray-500 hover:text-linkedin-blue'
                }
            />
        </a>
    )
}
